/* eslint-disable @typescript-eslint/no-unused-vars */

/**
 * Checks that `value` is assignable to `T`.
 */
export const assertType = <T>(value: T): void => {
    throw new Error('This code is supposed to be used only in typetests');
};
